﻿import { useFilterContext } from '../../contexts/filter-context'
import InputCheckbox from '../InputCheckbox/InputCheckbox'

const CustomerFilterCard = () => {
  const { filterState, filterReducer } = useFilterContext()
  
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.type) {
      case 'checkbox':
        filterReducer.setPropertyValue(event.target.name, event.target.checked)
        break
      default:
        filterReducer.setPropertyValue(event.target.name, event.target.value)
        break
    }
  }
  
  return (
    <div className='flex flex-col gap-3'>
      <InputCheckbox label='Visa endast flaggade kundvarv' id='filter-flagged' name='flagged' checked={!!filterState.filter.flagged} onCheckChanged={handleInputChange} className='py-4 gap-2 items-center' />
    </div>
  )
}

export default CustomerFilterCard
